/** @format */

import React, { FC, ReactElement, useState } from 'react';
import { PlatformIccidPoolNumber } from '../../../interfaces/platform/PlatformIccidPoolNumber';
import SimCardInterface from '../../../interfaces/platform/SimCardInterface';
import ActionButton from '../../../components/Buttons/CustomTextButton';
import { AlertDialog } from '../../lib/dialog/AlertDialog';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { operationOnSimcardConstants } from '../../../modules/simcard/operationOnSimcard';

type ReleasingESimCardType = {
    iccid: PlatformIccidPoolNumber;
    simCard: SimCardInterface;
    tariffPlanId: number | null;
    virtualComponentTemplateId: number | null;
    reloadPage(): void;
};

export const ReleasingESimCard: FC<ReleasingESimCardType> = ({
    iccid,
    simCard,
    reloadPage,
    virtualComponentTemplateId,
    tariffPlanId,
}): ReactElement | null => {
    const dispatch = useDispatch();
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertTitleDialog, setAlertTitleDialog] = useState<string | null>(null);
    const [alertDisplayMessage, setAlertDisplayMessage] = useState<string | null>(null);

    const sendReleasingEvent = (): void => {
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.putWithCallback(
            FormGeneralHelper.getUrl('/operation_on_sim_cards/' + simCard.id),
            operationOnSimcardConstants.SIM_CARD_ACTIVATE_PUT,
            {
                id: simCard.id,
                activationType: 12, // @todo change it
                activateWithTariff: tariffPlanId,
                virtualComponentTemplateId: virtualComponentTemplateId,
            },
            (data: any): void => {
                reloadPage();
                setAlertOpen(false);
            },
            { dispatchAfterCallback: false, dispatchErrorAfterCallback: true, propagateDataToCallback: true }
        );
    };

    return (
        <>
            <ActionButton
                callback={(): void => {
                    setAlertOpen(true);
                    setAlertTitleDialog('simcard:add.confirm_releasing_esim_sim_card');
                    setAlertDisplayMessage('simcard:add.confirm_releasing_esim_sim_card_description');
                }}
                callbackParam={{}}
                label="simcard:add.releasing_esim_sim_card"
                size="sm"
            />
            <AlertDialog
                open={alertOpen}
                titleDialog={alertTitleDialog ?? ''}
                displayMessage={alertDisplayMessage ?? ''}
                closeCallback={(): void => setAlertOpen(false)}
                confirmCallback={sendReleasingEvent}
            />
        </>
    );
};
